export const createStatusSlice = (set) => ({
  statuses: [],
  updateStatuses: (statusData) => {
    set({ statuses: statusData });
    // console.log("updateStatuses: ", statusData);
  },
});
